import { render } from "./ProfileEditFormPanelNewTheme.vue?vue&type=template&id=f8f7a13a&scoped=true"
import script from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanelNewTheme.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanelNewTheme.vue?vue&type=style&index=0&id=f8f7a13a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f7a13a"]])

export default __exports__